import styled from 'styled-components';
import { NewCompoundSearchResult } from '../../../dtos';
import CardHeader from '../CardHeader';
import CardDescription from '../CardDescription';
import CardBadges from '../CardBadges';
import CardPropertyTypes from '../CardPropertyTypes';
import CallToAction from '../../../../../new-components/cards/components/CallToAction';
import { isPropertySearchResult } from '../../../helpers';
import { EntityTypes } from '../../../../../new-lib/constants/common';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { useCallback } from 'react';
import CompoundCardPaymentPlan from './CompoundCardPaymentPlan';

interface CardDetailsProps {
  entity: NewCompoundSearchResult;
}
const CardDetails = ({ entity }: CardDetailsProps) => {
  const isMobile = useSelector((state: any) => state.app.isMobile);
  const { t } = useTranslation('search');
  const { locale } = useRouter();
  const description = entity.subtitle;

  const getDownPayment = () => {
    return entity?.developerPlan?.downPaymentPercentage
      ? `${parseInt(entity?.developerPlan?.downPaymentPercentage?.toString())}%`
      : '';
  };

  const entityHasOffers = useCallback(() => {
    return isPropertySearchResult(entity) ? entity.has_offers : entity.hasOffer;
  }, [entity]);

  return (
    <Container>
      <CardHeader
        name={entity.name}
        area={entity.areaName}
        developerLogo={entity.developerLogoUrl}
        description={description}
      />
      {!isMobile && <CardDescription description={description} />}

      <CardPropertyTypes propertyTypes={entity.propertyTypes} />

      <CardBadges badges={entity?.badges} hasOffer={entityHasOffers()} />

      <div className="card-footer">
        <CompoundCardPaymentPlan
          paymentPlan={{
            downPayment: getDownPayment(),
            developerPrice: entity?.developerPlan?.minPrice,
            resalePrice: entity?.resalePlan?.minPrice,
            currency:
              entity?.developerPlan?.currency ?? entity?.resalePlan?.currency
          }}
        />

        <CallToAction
          entity={entity}
          entityType={EntityTypes.COMPOUND}
          clickEventData={{}}
        />
      </div>
    </Container>
  );
};

const Container = styled.div`
  max-width: 100%;
  width: calc(100% - 320px);
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 0;
  flex: 1 0 0;
  height: 100%;

  & > *:not(.card-footer) {
    flex-grow: 1;
  }

  .card-footer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  @media (max-width: ${props => props.theme.breakPoints.mobile.max}) {
    padding: 0 16px;
    gap: 16px;
    width: 100%;
    .card-footer {
      flex-direction: column;
      align-items: start;
      justify-content: start;
      gap: 16px;
    }
  }
`;

export default CardDetails;
